const SocketClientTypes = {
  SENDER: "SENDER",
  WMS_RECIPIENT: "WMS_RECIPIENT",
  APP_RECIPIENT: "APP_RECIPIENT",
};

export default SocketClientTypes;
